import { watchDeleteLangFlow } from 'store/global/globalTranslation/sagas/watchDeleteFlow';
import { watchImportDefaultLanguage } from './watchImportDefaultLanguage';

export const sagasLanguage = [watchImportDefaultLanguage, watchDeleteLangFlow];
